import React, { Fragment, useEffect, } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { toast } from 'react-toastify';
import { omit, sortBy, groupBy, pickBy, get } from 'lodash';
import { format as formatDate } from 'date-fns';

import firebase, { functions } from '../../firebase';
import { fieldDisplayValue, } from '../../shared/util';
import { getCollectionData } from '../../shared/firebase';
import { generalSettingFields, } from '../../shared/models/setting';
import AdminPage from '../hocs/AdminPage';
import ModelFormModal from '../modals/ModelFormModal';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import EditButton from '../EditButton';

const { entries, keys } = Object;
const db = firebase.firestore();
const generalSettingRef = db.collection('settings').doc('general');

export default AdminPage(function AdminSettings (props) {
  const generalSetting = useDocumentSubscription(generalSettingRef);
  useEffect(() => {
    if(generalSetting === null) {
      generalSettingRef.set({ updatedAt: new Date(), }, { merge: true });
    }
  }, [generalSetting]);

  return (
    <div className="admin-exports container-fluid">
      <div className="p-4 bg-white my-4">
        <div className="d-flex justify-content-center mb-3">
          <h4>設定</h4>
        </div>
        <div className="d-flex justify-content-end mb-3 gap-1">
          <EditButton label="設定" itemRef={generalSettingRef} FormModal={ModelFormModal} formProps={{ title: '設定', fields: generalSettingFields(), }} />
        </div>
        <div className="mt-3">
          <table className="table table-bordered">
            <tbody>
              {
                entries(generalSettingFields()).map(([fieldName, fieldSettings]) => {
                  const { label, initialValue, hidden = _ => false, } = fieldSettings;
                  return (
                    <tr key={fieldName}>
                      <th className="table-secondary" style={{ minWidth: 200 }}>{label}</th>
                      <td>{fieldDisplayValue(generalSetting?.[fieldName] ?? initialValue, fieldSettings)}</td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});

